import cn from 'classnames';
import Button from 'components/button-new';
import useIsClient from 'hooks/common/use-is-client';
import useMobile from 'hooks/common/use-mobile';
import Image from "next/legacy/image";
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import AboutUsModal from '../about-us-modal';
import JudgeMeOverview from '../judge-me-overview';
import NutritionUsps from '../nutrition-usps';

interface Props {
  image: string;
  petType: 'dog' | 'cat';
}

/**
 * USP section. This is the section that is displayed on the landing page for new customers and both dogs and cats.
 */
const UspSection: React.FC<Props> = ({ image, petType }) => {
  const isClient = useIsClient();
  const isMobile = useMobile();
  const [isAboutUsModalOpen, setIsAboutUsModalOpen] = useState(false);

  return (
    <>
      <div className={cn(isClient && isMobile && 'container')}>
        <div className="flex-row bg-background-paper text-text-light-bg-secondary lg:flex">
          <div className="basis-1/2 pt-8 lg:py-11">
            <div className="lg:ml-auto lg:mr-[84px] lg:max-w-[496px]">
              <p className="mb-2 text-text-light-bg-primary mindset-24 lg:mindset-28">
                <FormattedMessage id="landingpage:collection-slider:title" />
              </p>

              <JudgeMeOverview />

              <p className="mt-2">
                <FormattedMessage
                  id={
                    petType === 'cat'
                      ? 'landingpage:problem-solver-cat:description'
                      : 'landingpage:problem-solver:description'
                  }
                  values={{
                    b: (chunks) => <b>{chunks}</b>,
                  }}
                />
              </p>

              <p className="mt-4">
                <FormattedMessage
                  id="landingpage:problem-solver:sub-headline"
                  values={{
                    b: (chunks) => <b>{chunks}</b>,
                  }}
                />
              </p>

              <NutritionUsps />

              <Button
                className="mt-4 lg:mt-8 lg:bg-other-white"
                layout="outline"
                onClick={() => setIsAboutUsModalOpen(true)}
                size="large"
              >
                <FormattedMessage id="landingpage:problem-solver:cta" />
              </Button>
            </div>
          </div>

          {/* desktop image  */}
          <div className="relative hidden basis-1/2 lg:block">
            <Image
              src={image}
              layout="fill"
              objectFit="cover"
              quality={100}
              priority
            />
          </div>
        </div>
      </div>
      <AboutUsModal
        isOpen={isAboutUsModalOpen}
        onClose={() => setIsAboutUsModalOpen(false)}
      />
    </>
  );
};

export default UspSection;
